import React from "react"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import {RouterLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Body, H3} from "@irati/ui/src/Typography"
import nothingFound from "@irati/ui/images/binoculars.svg"
import {SECTION_REWARDS} from "../../constants/search"

const NothingFound = (props, {apps}) => {
  const isRewards = window.location.pathname === `${apps.SEARCH}/${SECTION_REWARDS}`
  const idNamespace = id("nothing-found", props)
  const app = isRewards ? apps.FLEXIREWARDS : apps.PERKS

  return (
    <Flex id={idNamespace} direction="column" alignItems="center">
      <img id={id("img", idNamespace)} src={nothingFound} alt="search error" />
      <div>
        <H3 id={id("title", idNamespace)} margin={[1, 0]}>
          <FormattedMessage id="perks.components.searchAllResults.nothingFound.heading" />
        </H3>
        <Body id={id("body", idNamespace)}>
          <FormattedMessage id="perks.components.searchAllResults.nothingFound.message" />
          <br />
          <FormattedMessage id="perks.components.SearchAllResults.nothingFound.browse" />{" "}
          <RouterLink id={idNamespace} to="/" app={app} plain>
            {isRewards ? (
              <FormattedMessage id="perks.components.SearchAllResults.nothingFound.ourRewardsLink" />
            ) : (
              <FormattedMessage id="perks.components.SearchAllResults.nothingFound.ourPerksLink" />
            )}
          </RouterLink>
        </Body>
      </div>
    </Flex>
  )
}

NothingFound.contextTypes = {
  apps: PropTypes.object.isRequired
}

export default NothingFound
